import template from './ko-field-input-list.html';

class ListInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);

		this.label = ko.observable(params.label);
		this.$input = ko_helper.safe_observable(params.$input);
		this.help_text = ko.observable(params.help_text);

		this.options = ko.observableArray([]);
		this.optionsText = ko_helper.safe_observable(params.options_text || params.list_label_field, null);
		this.optionsValue = ko_helper.safe_observable(params.options_value || params.list_value_field, null);
		this.optionsCaption = ko_helper.safe_observable(params.caption, 'Select...');
		this.value = ko.observable();
		this.values = ko.observableArray([]);
		this.enableMultiple = ko_helper.safe_observable(params.multiselect, false);

		// Handle single value mode
		this.value.subscribe(val => {
			if (!val)
			{
				this.$input(null);
				return;
			}
			else if (val != this.$input())
				this.$input(val);
		});

		// Handle multiple values mode
		this.values.subscribe(vals => {
			if (!vals || vals.length === 0)
			{
				this.$input(null);
				return;
			}
			else if (JSON.stringify(vals) !== JSON.stringify(this.$input()))
				this.$input(vals);
		});

		this.$input.subscribe(val => {
			if (!val)
			{
				this.value(null);
				this.values([]);
				return;
			}
			
			if (this.enableMultiple())
			{
				// For multiple selection, expect an array
				if (Array.isArray(val))
				{
					// Filter out null, undefined, and empty values
					let filteredVal = val.filter(v => v !== null && v !== undefined && v !== '');
					if (JSON.stringify(filteredVal) !== JSON.stringify(this.values()))
						this.values(filteredVal);
				}
				else
				{
					// Convert single value to array if not null/undefined/empty
					if (val !== null && val !== undefined && val !== '')
						this.values([val]);
					else
						this.values([]);
				}
			}
			else
			{
				// For single selection - single value
				if (Array.isArray(val))
				{
					// Take first value from array
					let singleVal = val.length > 0 ? val[0] : null;
					if (singleVal != this.value())
						this.value(singleVal);
				}
				else if (val != this.value())
					this.value(val);
			}
		});

		this.load_options();
	}

	async load_options()
	{
		let rawItems = [];
		let options = this.params.options || this.params.ui_fields?.options;

		// 1. Items from cache
		if (this.params.items_from_cache || this.params.ui_fields?.items_from_cache)
		{
			let cache;
			if (this.params.items_from_cache)
				cache = this.params.items_from_cache;
			else
				cache = this.params.ui_fields.items_from_cache;

			if (cache == 'AllCaches')
			{
				let x = Grape.cache.cache_items || {};
				rawItems = Object.keys(x);
				this.optionsText('text');
				this.optionsValue('value');
			}
			else
			{
				try
				{
					rawItems = await Grape.cache.get(cache);

					// Ensure proper text/value fields for cache items
					if (Array.isArray(rawItems) && rawItems.length > 0)
					{
						let first = rawItems[0];
						if (typeof first === 'string' || typeof first === 'number')
						{
							rawItems = rawItems.map(i => ({ text: String(i), value: i }));
							this.optionsText('text');
							this.optionsValue('value');
						}
						else if (typeof first === 'object')
						{
							// Check if name/value fields
							if (first.hasOwnProperty('name') && !this.optionsText())
								this.optionsText('name');

							// Only set optionsValue if specified in params
							if (this.params.options_value || this.params.list_value_field)
							{
								if (first.hasOwnProperty('value'))
									this.optionsValue('value');
							}
							// If no optionsText, find a suitable display field
							if (!this.optionsText())
							{
								let keys = Object.keys(first);
								let stringKey = keys.find(k => typeof first[k] === 'string' || typeof first[k] === 'number');
								if (stringKey)
									this.optionsText(stringKey);
							}
						}
					}
				} catch (err)
				{
					console.error('Cache error:', err);
					rawItems = [];
				}
			}
		}
		// 2. Lookup
		else if (this.params.lookup || this.params.ui_fields?.lookup)
		{
			let res = await Grape.fetches.getJSON('/api/record', {
				schema: 'grape',
				table: 'v_lookup_value',
				filter: [{ field: 'lookup_name', operand: '=', value: this.params.lookup }]
			});

			rawItems = res.records || [];
			if (!this.optionsText()) this.optionsText('name');
			if (!this.optionsValue()) this.optionsValue('lookup_value_id');
		}

		// 3. Custom fetch function
		else if (this.params.fetch_items instanceof Function)
			rawItems = await this.params.fetch_items(this) || [];

		// 4. Manual items (only if no cache/lookup/fetch)
		else if (this.params.items)
		{
			if (typeof this.params.items === 'string')
			{
				try
				{
					// Handle string that looks like an array (e.g. "['Yes', 'No']")
					if (this.params.items.trim().startsWith('[') && this.params.items.trim().endsWith(']'))
					{
						let content = this.params.items.trim().slice(1, -1);
						rawItems = content.split(',').map(item =>
							item.trim().replace(/^['"]|['"]$/g, '')
						);
					}
					else
					{
						try {
							rawItems = JSON.parse(this.params.items);
						} catch {
							rawItems = this.params.items.split(',').map(item => item.trim().replace(/^['"]|['"]$/g, ''));
						}
					}
				} catch (err)
				{
					console.error('Invalid manual items:', err);
					rawItems = [];
				}
			}
			else if (Array.isArray(this.params.items))
				rawItems = this.params.items;
		}
		// 5. Legacy manual options (only if no other source)
		else if (options)
		{
			if (typeof options === 'string')
			{
				try
				{
					// Handle string that looks like an array (e.g. "['Yes', 'No']")
					if (options.trim().startsWith('[') && options.trim().endsWith(']'))
					{
						let content = options.trim().slice(1, -1);
						rawItems = content.split(',').map(item =>
							item.trim().replace(/^['"]|['"]$/g, '')
						);
					}
					else
					{
						try {
							rawItems = JSON.parse(options);
						} catch {
							rawItems = options.split(',').map(item => item.trim().replace(/^['"]|['"]$/g, ''));
						}
					}
				} catch (err)
				{
					console.error('Invalid manual options:', err);
					rawItems = [];
				}
			}
			else if (Array.isArray(options))
				rawItems = options;
		}

		// Normalize items array
		let items = [];
		let first = rawItems[0];

		if (typeof first === 'string' || typeof first === 'number')
		{
			items = rawItems.map(i => ({ text: String(i), value: i }));
			this.optionsText('text');
			this.optionsValue('value');
		}
		else if (first && typeof first === 'object')
		{
			items = rawItems;
			if (!this.optionsText()) this.optionsText('name');
		}

		this.options(items);

		// Set value/values
		let currentValue = this.$input();
		if (this.enableMultiple())
		{
			if (Array.isArray(currentValue))
			{
				// Filter out null, undefined, and empty values
				let filteredValue = currentValue.filter(v => v !== null && v !== undefined && v !== '');
				this.values(filteredValue);
			}
			else if (currentValue !== null && currentValue !== undefined && currentValue !== '')
				this.values([currentValue]);
			else
				this.values([]);
		}
		else
		{
			// For single select - single value
			if (Array.isArray(currentValue))
			{
				let singleVal = currentValue.length > 0 ? currentValue[0] : null;
				this.value(singleVal);
			}
			else // single value
				this.value(currentValue);
		}
	}
}

export default {
	name: 'ko-field-input-list',
	viewModel: ListInputComponentVM,
	module_type: 'ko',
	template: template
}
